import React, { Component, Suspense } from "react";
import { Row, Col } from "reactstrap";
import {
  AppBreadcrumb,
  AppSidebar,
  // AppSidebarFooter,
  // AppSidebarForm,
  // AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav
} from "@coreui/react";
// sidebar nav config
import navigation from "../../_nav";
// routes config
import routes from "../../routes";
import DefaultRoutes from "./DefaultRoutes";
import { inject, observer } from "mobx-react";
import { reactLocalStorage } from "reactjs-localstorage";
import { getPermissions, addPermisssions, getAdminsSelect, removePermissions } from "../../services/AdminService";
import ReactSelectComponent from "../../components/ReactSelectComponent";
import CommonStore from "../../stores/CommonStore";
import { LSNAME, ROLE } from "../../helper/constants/constants";
import { RoleOption } from "../../helper/constants/options";
import { MaterialDialogConfirmation } from "../../components/MaterialDialog";
import _ from 'lodash';

const InitDialog = {
  dialogShow: false,
  dialogLoading: false,
  dialogTitle: '',
  dialogActionConfirm: ''
}
class DefaultLayout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      custompermission: null,
      rolepermissions: null,
      temprolepermissions: null,
      options: [
        ...RoleOption,
        { value: ROLE.DEVELOPER, label: "Developer" }
      ],
      ...InitDialog,
      addordelete: "add", // add | delete
      width: 0,
      height: 0
    }
  }

  componentWillMount() {
    this.unlisten = this.props.prop.history.listen((location, action) => {
      this.loadNavigation()
    });
  }
  componentWillUnmount() {
    this.unlisten();
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount = async () => {
    this.loadNavigation();
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  loadNavigation = async () => {
    try {
      const currentUserString = reactLocalStorage.get(LSNAME.ADMIN);
      let currentUser = JSON.parse(currentUserString)
      let { data, error } = await getPermissions(currentUser.role, currentUser._id);
      if (error) throw error;
      let childmenuname = "";
      // let parentmenu = "";
      for (let i = 0; i < navigation.items.length; i++) {
        let route = navigation.items[i].children
        if (route) {
          for (let j = 0; j < route.length; j++) {
            if (this.props.location.pathname === route[j].url) {
              childmenuname = route[j].menuname
              // parentmenu = navigation.items[i].name
            }
          }
        }
      }
      let newoptions = []
      if (currentUser.role === ROLE.SUPERADMIN) {
        this.state.options.forEach(value => {
          data.forEach(datavalues => {
            if (value.value === datavalues.role) {
              datavalues.childmenu.forEach(childmenu => {
                if (childmenu === childmenuname) {
                  newoptions.push(value);
                }
              })
            }
          })
        })
        data.forEach(datavalues => {
          if (datavalues.admin) {
            datavalues.childmenu.forEach(childmenu => {
              if (childmenu === childmenuname) {
                newoptions.push({
                  value: datavalues.admin._id,
                  label: datavalues.admin.name,
                  data: datavalues.admin
                });
              }
            })
          }
        })
        data = data[0]
      } else {
        let newData = {
          parentmenu: [],
          listpermission: [],
          childmenu: [],
        }
        for ( let i = 0; i < data.length; i ++) {
          if (newData.parentmenu) {
            newData.parentmenu = [
              ...newData.parentmenu,
              ...data[i].parentmenu
            ]
          } else { newData.parentmenu = data[i].parentmenu }
          if (newData.listpermission) {
            newData.listpermission = [
              ...newData.listpermission,
              ...data[i].listpermission ? data[i].listpermission : []
            ]
          } else { newData.listpermission = data[i].listpermission ? data[i].listpermission : [] }
          if (newData.childmenu) {
            newData.childmenu = [
              ...newData.childmenu,
              ...data[i].childmenu
            ]
          } else { newData.childmenu = data[i].childmenu }
        }
        // data = data[0]
        data = newData
      }
      this.setState({
        custompermission: data,
        rolepermissions: newoptions
      })
    } catch (error) {
      CommonStore.showErrorMessage(error.message || error);
    }
  }

  onChangeSpecialRolePermission = (event) => {
    let title = "Apakah anda yakin ingin menghapus otorisasi untuk role ini ?"
    let addordelete = "Delete"
    if (this.state.rolepermissions && event) {
      if (event.length < this.state.rolepermissions.length) {
        title = "Apakah anda yakin ingin menghapus otorisasi untuk role ini ?"
        addordelete = "Delete"
      } else {
        title = "Apakah anda yakin ingin menambah otorisasi untuk role ini ?"
        addordelete = "Add"
      }
    } else if (!this.state.rolepermissions) {
      title = "Apakah anda yakin ingin menambah otorisasi untuk role ini ?"
      addordelete = "Add"
    } else if (!event) {
      title = "Apakah anda yakin ingin menghapus otorisasi untuk role ini ?"
      addordelete = "Delete"
    }
    this.setState({
      dialogShow: true,
      dialogTitle: title,
      dialogActionConfirm: addordelete,
      addordelete: addordelete,
      temprolepermissions: event,
    })
  }

  loadAdminInfo = async (e) => {
    try {
      let { data, error } = await getAdminsSelect({searchQuery: e});
      let adminList = []
      if (data) { 
        adminList = data.admins.map(value => {
          let isDisabled = false
          this.state.rolepermissions.map(rolevalue => {
            if (rolevalue.value === value.role) { 
              isDisabled = true
            }
          })
          return {
            value: value._id,
            label: `${value.name} - ${value.username}`,
            isDisabled
          }
        })
      }
      let options = this.state.options.map( value => {
        let isDisabled = false
        this.state.rolepermissions.map(adminValue => {
          if (adminValue.data.role === value.value) { 
            isDisabled = true
          }
        })
        return {
          value: value.value,
          label: `${value.label}`,
          isDisabled
        }
      })
      adminList = [
        ...options,
        ...adminList
      ]
      return adminList
    } catch (error) {
      return []
    }
  }

  onConfirm = async () => {
    try {
      let childmenuname = ""
      let parentmenu = ""

      for (let i = 0; i < navigation.items.length; i++) {
        let route = navigation.items[i].children
        if (route) {
          for (let j = 0; j < route.length; j++) {
            if (this.props.location.pathname === route[j].url) {
              childmenuname = route[j].menuname
              parentmenu = navigation.items[i].name
            }
          }
        }
      }

      if (this.state.addordelete === "Add") {
        this.state.temprolepermissions.map(async value => {
          let { error, data } = await addPermisssions({ role: value.value, menu: parentmenu, childmenu: childmenuname })
          if (error) throw error
          if (!data) throw 'Data is null';
        })
      }

      if (this.state.addordelete === "Delete") {
        let rolepermissionsname = ""
        for (let i = 0; i < this.state.rolepermissions.length; i++) {
          let exist = false
          if (this.state.temprolepermissions) {
            for (let j = 0; j < this.state.temprolepermissions.length; j++) {
              if (this.state.rolepermissions[i].value === this.state.temprolepermissions[j].value) {
                exist = true
                break;
              }
            }
          }
          if (exist === false) {
            rolepermissionsname = this.state.rolepermissions[i].value
          }
        }
        let { error, data } = await removePermissions({ role: rolepermissionsname, childmenu: childmenuname })
        if (error) throw error
        if (!data) throw 'Data is null';
      }

      this.setState({
        rolepermissions: this.state.temprolepermissions,
        temprolepermissions: null,
        dialogLoading: false,
        dialogShow: false,
      })

    } catch (error) {
      CommonStore.showErrorMessage(error.message || error);
      this.setState({ dialogLoading: false });
    }
  }

  render() {
    /* Validate CurrentRole */
    const currentUserString = reactLocalStorage.get(LSNAME.ADMIN);
    const permission = reactLocalStorage.getObject(LSNAME.PERMISSION);
    const ls = reactLocalStorage.getObject(LSNAME.LIST_REGION);
    const custompermission = this.state.custompermission;
    let multiRegion = false;

    if (currentUserString) {
      this.currentUser = JSON.parse(currentUserString);
    };

    if (!_.isEmpty(ls) && ls.length > 1) {
      multiRegion = true
    }

    let userRoleisSuperAdmin = (this.currentUser.role === ROLE.SUPERADMIN)

    const multiRegionStyle = {
      fontSize: '8px',
      fontWeight: 'bold',
      backgroundColor: '#4dbd74',
      color: '#fff',
      padding: 2,
      paddingLeft: 8,
      paddingRight: 8,
      borderRadius: 4
    }

    const items = [];
    let objectspecialpermission = {}
    navigation.items.forEach(nav => {

      let obj = null;
      let exist = false;

      if (custompermission) {
        custompermission.parentmenu.forEach(parentvalue => {
          if (nav.name === parentvalue) {
            obj = {};
            obj.name = nav.name;
            obj.url = nav.url;
            obj.icon = nav.icon;
            // if (nav.isMulti) { obj.name = (<span>{nav.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
            if ((nav.isMulti && userRoleisSuperAdmin) || (nav.isMulti && multiRegion)) { 
              // obj.name = (<span class="multi-region">{obj.name}</span>)
              obj.name = (<span className="multi-region">{nav.name}<br/><span className="parent-multi" style={multiRegionStyle}>Multi Region</span></span>)
              obj.icon = nav.multiIcon 
            }
            obj.children = [];
            exist = true;
          }
        })
      }

      if (nav.permission) {
        if (permission[nav.permission] || (nav.specialpermission && nav.specialpermission.indexOf(this.currentUser.role) > -1)) {
          //check if exist
          if (!exist) {
            obj = {};
            obj.name = nav.name;
            obj.url = nav.url;
            obj.icon = nav.icon;
            // if (nav.isMulti) { obj.name = (<span>{nav.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
            if ((nav.isMulti && userRoleisSuperAdmin) || (nav.isMulti && multiRegion)) { 
              // obj.name = (<span class="multi-region">{obj.name}</span>)
              obj.name = (<span className="multi-region">{nav.name}<br/><span className="parent-multi" style={multiRegionStyle}>Multi Region</span></span>)
              obj.icon = nav.multiIcon 
            }
          }
        }
      } else {
        if (!exist) {
          obj = {};
          obj.name = nav.name;
          obj.url = nav.url;
          obj.icon = nav.icon;
          // if (nav.isMulti) { obj.name = (<span>{nav.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
          if ((nav.isMulti && userRoleisSuperAdmin) || (nav.isMulti && multiRegion)) { 
            // obj.name = (<span class="multi-region">{obj.name}</span>)
            obj.name = (<span className="multi-region">{nav.name}<br/><span className="parent-multi" style={multiRegionStyle}>Multi Region</span></span>)
            obj.icon = nav.multiIcon 
          }
        }
      }

      let ok = false;
      (nav.permission && (permission[nav.permission]) || (nav.specialpermission && nav.specialpermission.indexOf(this.currentUser.role) > -1)) ? ok = true : ok = false;
      if (!nav.permission && !ok) {
        ok = true;
      }
      if (exist) {
        ok = true;
      }

      if (ok && nav.children) {
        if (!exist) {
          obj.children = [];
        }
        nav.children.forEach(child => {
          let childexist = false
          if (exist) {
            custompermission.childmenu.forEach(childvalue => {
              if (child.menuname === childvalue) {
                let childObj = null;
                childObj = {};
                childObj.name = child.name;
                childObj.url = child.url;
                childObj.icon = child.icon;
                // if (child.isMulti) { childObj.name = (<span>{childObj.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
                if ((child.isMulti && userRoleisSuperAdmin) || (child.isMulti && multiRegion)) { 
                  childObj.name = (<span className="multi-region">{childObj.name}<br/><span className="child-multi" style={multiRegionStyle}>Multi Region</span></span>)
                  childObj.icon = child.multiIcon 
                }
                objectspecialpermission[child.name] = true
                obj.children.push(childObj);
                childexist = true
              }
            })
          }
          if (child.permission) {
            let childObj = null;
            if (permission[child.permission] || (child.specialpermission && child.specialpermission.indexOf(this.currentUser.role) > -1)) {
              childObj = {};
              childObj.name = child.name;
              childObj.url = child.url;
              childObj.icon = child.icon;
              // if (child.isMulti) { childObj.name = (<span>{childObj.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
              if ((child.isMulti && userRoleisSuperAdmin) || (child.isMulti && multiRegion)) { 
                childObj.name = (<span className="multi-region">{childObj.name}<br/><span className="child-multi" style={multiRegionStyle}>Multi Region</span></span>)
                childObj.icon = child.multiIcon 
              }
            }
            if (childObj && !childexist) {
              obj.children.push(childObj);
            }
          } else {
            if (!childexist) {
              let childObj = {};
              childObj.name = child.name;
              childObj.url = child.url;
              childObj.icon = child.icon;
              // if (child.isMulti) { childObj.name = (<span>{childObj.name}<br/><span style={multiRegionStyle}>Multi Region</span></span>) }
              if ((child.isMulti && userRoleisSuperAdmin) || (child.isMulti && multiRegion)) { 
                childObj.name = (<span className="multi-region">{childObj.name}<br/><span className="child-multi" style={multiRegionStyle}>Multi Region</span></span>)
                childObj.icon = child.multiIcon 
              }
              obj.children.push(childObj);
            }
          }
        })
      }

      ok = false;

      if (nav.children) {
        if (obj && obj.children.length <= 0) {
          ok = false;
        } else {
          ok = true;
        }
      }
      if (!nav.children) {
        ok = true;
      }

      if (ok && obj) {
        if (obj.children) {
          if (obj.children.length !== 0) {
            items.push(obj);
          }
        } else {
          items.push(obj);
        }
      }

    })

    let navItems = {};
    navItems.items = items;
    return (
      <div className="app-body">
        {/* minimized */}
        {/* {(this.props.location.pathname.split('/')[2] === "kpi" || this.props.location.pathname.split('/')[2] === "timetable" || this.props.location.pathname.split('/')[2] === "chat" 
          || this.props.location.pathname.split('/')[2] === "chat-messages") && (
          <AppSidebar fixed minimized display="lg">
            <Suspense>
              <AppSidebarNav navConfig={navItems} {...this.props} />
            </Suspense>
            <AppSidebarMinimizer />
          </AppSidebar>
        )} */}
        {/* {this.props.location.pathname.split('/')[2] !== "kpi" && this.props.location.pathname.split('/')[2] !== "timetable" && this.props.location.pathname.split('/')[2] !== "chat"
          && this.props.location.pathname.split('/')[2] !== "chat-messages" && ( */}
          <AppSidebar fixed display="lg">
            <Suspense>
              <AppSidebarNav navConfig={navItems} {...this.props} />
            </Suspense>
            <AppSidebarMinimizer />
          </AppSidebar>
        {/* )} */}
        <main className="main">
            {/* {this.props.location.pathname.split('/')[2] !== "kpi" && this.props.location.pathname.split('/')[2] !== "timetable" && this.props.location.pathname.split('/')[2] !== "chat"  */}
            {this.props.location.pathname.split('/')[2] !== "chat" 
            && this.props.location.pathname.split('/')[2] !== "chat-messages" && (
            <Row fluid="true" className="p-lr-15 mb-3 style-label">
                <Col xs="12" md="6" className="pl-0 mt-2" style={{ maxHeight: '30px' }}>
                  <AppBreadcrumb appRoutes={routes} />
                </Col>
              {this.props.location.pathname.split('/')[2] === "reports" && this.currentUser.role === ROLE.SUPERADMIN && (
                <Col xs="12" md="6" className="mt-2">
                  <Row>
                    <Col md="4" className={`d-flex ${this.state.width < 900 ? "pr-0 mt-2" : "pr-0 text-right"}`} style={{ alignItems: 'center' }}>
                      <small className="text-muted" style={{ width: '100%' }}>SPECIAL ROLE PERMISSION</small>
                    </Col>
                    <Col md="8">
                      <ReactSelectComponent
                        isClearable={false}
                        key={this.state.rolepermissions}
                        name={"statusMembers"}
                        value={this.state.rolepermissions}
                        // options={this.state.options}
                        async
                        loadOptions={this.state.rolepermissions ? this.loadAdminInfo : async () => { return [] } }
                        defaultOptions
                        onChange={this.onChangeSpecialRolePermission}
                        isMulti={true}
                      />
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
          )}
          <DefaultRoutes routes={routes} prop={this.props.prop} />
        </main>

        <MaterialDialogConfirmation
          open={this.state.dialogShow}
          title={this.state.dialogTitle}
          actionLoading={this.state.dialogLoading}
          actionCancel="Cancel"
          actionConfirm={this.state.dialogActionConfirm}
          onClickCancel={() => this.setState({ dialogShow: false })}
          onClickConfirm={this.onConfirm}
        />
      </div>
    );
  }
}

export default inject("authStore", "commonStore")(observer(DefaultLayout));